import { EElectronicTrading } from 'shared/types/filters/advanced/electronicTrading';

export const electronicTradingLabel = {
  [EElectronicTrading.WithoutTrading]: 'Не показывать',
  [EElectronicTrading.WithTrading]: 'Только торги и залоговая недвижимость',
};
